"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _DialogOffline = _interopRequireDefault(require("./components/DialogOffline"));
var _Reader = _interopRequireDefault(require("./components/Reader"));
var _EpubView = _interopRequireDefault(require("./components/EpubView"));
var _contexts = require("./contexts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// External Libraries

// Components

// Contexts

function App(_ref) {
  var {
    userId,
    uuid,
    bookTitle,
    applicationToken,
    sessionToken,
    backToBds
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.SaraivaTheme, null, /*#__PURE__*/_react.default.createElement(_contexts.EpubReaderProvider, {
    userId: userId,
    uuid: uuid,
    bookTitle: bookTitle,
    applicationToken: applicationToken,
    sessionToken: sessionToken,
    backToBds: backToBds
  }, /*#__PURE__*/_react.default.createElement(_contexts.SearchProvider, null, /*#__PURE__*/_react.default.createElement(_contexts.BookmarksProvider, null, /*#__PURE__*/_react.default.createElement(_contexts.CopyrightProvider, null, /*#__PURE__*/_react.default.createElement(_contexts.SideBarProvider, null, /*#__PURE__*/_react.default.createElement(_contexts.HighlightsProvider, null, /*#__PURE__*/_react.default.createElement(_contexts.ReaderPreferencesProvider, null, /*#__PURE__*/_react.default.createElement(_Reader.default, null, /*#__PURE__*/_react.default.createElement(_EpubView.default, null), /*#__PURE__*/_react.default.createElement(_DialogOffline.default, null))))))))));
}
App.propTypes = {
  userId: _propTypes.default.number.isRequired,
  uuid: _propTypes.default.string.isRequired,
  bookTitle: _propTypes.default.string.isRequired,
  applicationToken: _propTypes.default.string.isRequired,
  sessionToken: _propTypes.default.string.isRequired,
  backToBds: _propTypes.default.func
};
App.defaultProps = {
  backToBds: () => {}
};
var _default = exports.default = App;